import React from 'react'
import { graphql } from 'gatsby'

// Components
import SEO from 'components/shared/SEO'
import Layout from 'components/layout/Layout'
import FlexContentHandler from 'components/shared/FlexContentHandler'

interface PageProps {
  data: {
    page: {
      title?: string
      path?: string
      seo: any
      flexContent: any
    }
  }
  location?: any
}

const PageTemplate: React.FC<PageProps> = ({
  data: {
    page: { flexContent, seo },
  },
  location = {},
}) => (
  <Layout>
    <SEO seo={seo} />
    <FlexContentHandler fields={flexContent} location={location} />
  </Layout>
)

export const pageQuery = graphql`
  query pageById($pageId: String!) {
    page: wpPage(id: { eq: $pageId }) {
      ...generalPageFragment
    }
  }
`

export default PageTemplate
